// components/NotifyBadge.jsx
import React from "react";
import useCountBump from "../hooks/useCountBump";

export default function NotifyBadge({ count }) {
  const bump = useCountBump(count);

  if (!count || count <= 0) return null;

  return (
    <span className={`absolute -top-2 -right-2 text-white text-xs rounded-full px-2 py-0.5 
      bg-red-600 shadow-sm ${bump ? "animate-badge-pop ring-2 ring-red-300" : ""}`}>
      {count}
      {/* halo ping discret */}
      <span className={`absolute inset-0 rounded-full ${bump ? "animate-ping" : "hidden"}`}></span>
    </span>
  );
}
